import { render } from "./News02.vue?vue&type=template&id=7609f281&scoped=true"
import script from "./News02.vue?vue&type=script&lang=js"
export * from "./News02.vue?vue&type=script&lang=js"

import "./News02.vue?vue&type=style&index=0&id=7609f281&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7609f281"]])

export default __exports__